<template>
	<div class="formTabWrapper">
		<div class="formTabTableWrap">
			<div class="formTabTableWrap_top">
				<div class="formTabTableWrap_top-title">Repairs</div>
				<div class="formTabTableWrap_top-add"></div>
			</div>
			<div class="formTabTableWrap_body">
				<work-orders-table
						v-if="workOrdersFilter"
						:workOrdersFilterDefault="workOrdersFilterDefault"
						:filter="workOrdersFilter"
						:list-items="workOrdersList"
						:permissions="permissions"
						:defValue="truckId"
						defFilter="filter_truck_id"
						:isFilterList="isFilterList"
						@updateEdit="onEdit"
						@updateRemoveItem="getRemoveItem"
						@updateCommentsPopup="onCommentsPopup"
				></work-orders-table>
			</div>
		</div>

		<remove-block
				v-if="isRemove"
				@updateRemoveItem="onRemoveItem"
				@updateRemoveClose="onRemoveClose"
		></remove-block>

		<comments-popup
				v-if="isCommentsPopup"
				:commentsList="commentsList"
				:commentsData="commentsData"
				@updateCloseComments="onCloseComments"
		></comments-popup>

		<add-work-orders
				v-if="isWorkOrders"
				:currentId="currentId"
				:getPermissionAction="getPermissionAction"
				:permissions="permissions"
				@updateClose="onAddWorkOrder(false)"
				@updateFilterList="onFilterList"
		></add-work-orders>

	</div>
</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// components
import WorkOrdersTable from "@/components/Fleet/WorkOrders/WorkOrdersTable/WorkOrdersTable";
// async components
const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");
const CommentsPopup = () => import("@/components/Fleet/WorkOrders/CommentsPopup/CommentsPopup");
const AddWorkOrders = () => import("@/components/Fleet/WorkOrders/AddWorkOrders/AddWorkOrders");
// helpers
import getUniqId from "@/helper/getUniqId";
// mixins
import removeMixins from "@/mixins/removeMixins";
// constants
import { PERMISSIONS } from "@/constants/constants";

export default {
	name: "SecondTab",
	mixins: [ removeMixins ],
	props: {
		truckId: Number
	},
	components: {
		WorkOrdersTable,
		CommentsPopup,
		RemoveBlock,
		AddWorkOrders
	},
	computed: {
		...mapGetters([ 'workOrdersFilter', 'workOrdersList', 'permissions', 'workOrdersFilterDefault', 'permissionsDefault' ]),
		allPermissions() {
			return this.permissionsDefault;
		},
		getPermissionAction() {
			if ((this.permissions[PERMISSIONS.CREATE] && !this.currentId) || this.permissions[PERMISSIONS.EDIT]) return false;
			return this.permissions[PERMISSIONS.VIEW];
		}
	},
	data: () => ({
		isCommentsPopup: false,
		isRemove: false,
		isWorkOrders: false,
		commentsList: [],
		commentsData: null,
		currentId: null,
		isFilterList: null,
	}),
	methods: {
		...mapActions([
			'onWorkOrders',
			'onWorkOrderComments',
			'onRemoveWorkOrder',
			'onWorkOrdersPreloader',
			'onClearWOFilter',
			'setPermitToSection'
		]),
		onFilterList() {
			this.isFilterList = getUniqId();
		},
		onEdit(id) {
			if (this.permissions[9] || this.permissions[10]) {
				this.currentId = id;
				this.isWorkOrders = true;
			}
		},
		onAddWorkOrder(value) {
			this.currentId = null;
			this.isWorkOrders = value;
		},
		getRemoveItem(id) {
			this.removeItem = id;
			this.isRemove = true;
		},
		async onCommentsPopup({ id, unit, unit_type }) {
			this.commentsData = { unit, unit_type };
			this.commentsList = await this.onWorkOrderComments(id);
			this.isCommentsPopup = true;
		},
		onCloseComments() {
			this.isCommentsPopup = false;
		},
		async onRemoveItem() {
			await this.onRemoveWorkOrder(this.removeItem);
			this.isRemove = false;
		}
	},
	async mounted() {
		await this.onWorkOrdersPreloader(true);
		await this.onWorkOrders(null);
		await this.setPermitToSection('Trucks');
	},
	destroyed() {
		this.onClearWOFilter();
	}
};
</script>
<style scoped lang="scss">
@import "@/assets/style/components/formTab/formTabTableWrap";
</style>
